import { get, post, del } from "#lib/api-client.js";
import type {
	NotificationListResponse,
	Notification,
	WsTokenResponse,
} from "#lib/api-client/types.gen.js";

export async function listNotifications(
	limit = 20,
	cursor?: string,
): Promise<NotificationListResponse> {
	const params = new URLSearchParams();
	params.append("limit", String(limit));
	if (cursor) params.append("cursor", cursor);
	return get(`/notifications?${params.toString()}`);
}

export async function getUnreadNotificationCount(): Promise<number> {
	const response = await get<{ count: number }>("/notifications/unread-count");
	return response.count;
}

export async function markNotificationRead(id: string): Promise<Notification> {
	return post(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<{ message: string }> {
	return post("/notifications/read-all");
}

export async function deleteNotification(id: string): Promise<{ message: string }> {
	return del(`/notifications/${id}`);
}

export { type Notification };

/**
 * Mints the short-lived token used for the WebSocket handshake. The session
 * cookie is HttpOnly and cannot be read by the browser, so the socket cannot
 * authenticate with it directly.
 */
export async function getRealtimeToken(): Promise<WsTokenResponse> {
	return get("/auth/ws-token");
}
